export default __webpack_public_path__ + "static/media/strokeQuestion.ac969348.svg";